// extracted by mini-css-extract-plugin
module.exports = {"durationInput":"duration-input-module--duration-input--1X4V5"};